import {
  ProductCardTypes,
  TestPrepLevelStat,
  TestPrepProductAPIStat,
  TestPrepProductUIStat,
} from '~/redux/apis/user-stats-api'
import { convertMsToDayHourMinute } from '~/user-stats/utility/date.utils'
import ROUTES from '~/shared/constants/routes.const'

export default function useTestPrepProductCardStats(productStat: TestPrepProductAPIStat): TestPrepProductUIStat {
  const {
    id,
    gradeTitle,
    curriculumCountryCode,
    timeSpentInSec,
    scoreSummary: { totalQuestionsCount, answeredQuestionsCount, correctAnswersCount },
    levelsByDate,
    lastVisited,
  } = productStat

  const timeSpentInMs = timeSpentInSec * 1000
  const { days, hours, minutes } = convertMsToDayHourMinute(timeSpentInMs)

  const processedLevelsByDate = Object.entries(levelsByDate).reduce((acc, [date, levelStat]) => {
    acc[date] = {
      ...levelStat,
      testSet: levelStat.testSet.map((test) => ({
        ...test,
        correctnessPercentage: Math.ceil(test.correctnessPercentage),
        allScores: test.allScores.map((score) => ({
          ...score,
          correctnessPercentage: Math.ceil(score.correctnessPercentage),
        })),
      })),
    }
    return acc
  }, {} as { [key: string]: TestPrepLevelStat })

  const correctnessPercentage = totalQuestionsCount ? Math.ceil((correctAnswersCount / totalQuestionsCount) * 100) : 0

  return {
    id,
    type: ProductCardTypes.TEST_PREP,
    gradeTitle,
    curriculumCountryCode,
    timeSpent: {
      days,
      hours,
      minutes,
    },
    scoreSummary: {
      totalQuestionsCount,
      answeredQuestionsCount,
      correctAnswersCount,
    },
    testBuildUrl: ROUTES.TEST_START,
    correctnessPercentage,
    levelsByDate: processedLevelsByDate,
    lastVisited,
  }
}
